module.exports = __webpack_public_path__ + "img/2_1-residenziale-appartamenti-1.0b9f8aa0.png";